module.exports = __webpack_public_path__ + "img/guitar-electric.bed871a1.svg";